/* eslint-disable @typescript-eslint/no-explicit-any */
// Canned GraphQL responses for dev mock mode. Objects include __typename
// because the Apollo client adds it to every selection set.

const isoDaysAgo = (days: number) => new Date(Date.now() - days * 86400000).toISOString()
const isoMinutesFromNow = (min: number) => new Date(Date.now() + min * 60000).toISOString()

let counter = 1000
const newId = () => `mock-${counter++}-0000-0000-0000-000000000000`

const apps = [
    { __typename: 'App', id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890', name: 'Acme Store', key: 'sk_live_8Kc92mDp4Qx7Rz1Lv6Nw3Ty', s2sUrl: 'https://acme.example.com/callback' },
    { __typename: 'App', id: 'b2c3d4e5-f6a7-8901-bcde-f23456789012', name: 'Demo Shop', key: 'sk_live_2Hf71nApLm0Bk5Dq9Xc4Vs8', s2sUrl: 'https://demo.example.com/s2s' },
]

const mkPriceList = (MMK?: number, USD?: number) => ({ __typename: 'PriceList', MMK: MMK ?? null, USD: USD ?? null })

const products = [
    { __typename: 'Product', id: '1f8d3c2a-9b14-4f7e-bb20-7c2a1e9d4f01', title: 'Premium Plan', priceList: mkPriceList(15000, 12), createdAt: isoDaysAgo(20) },
    { __typename: 'Product', id: '7a2e9c41-0d63-4a18-9f55-3b8c6e2a1d77', title: 'Starter Pack', priceList: mkPriceList(5000, 4), createdAt: isoDaysAgo(12) },
    { __typename: 'Product', id: 'c4b81f09-7e2d-4c91-a3f6-9d0b5a8e2c33', title: 'Annual Subscription', priceList: mkPriceList(120000, 90), createdAt: isoDaysAgo(5) },
]

const mkOrder = (over: any) => ({
    __typename: 'Order', id: newId(), currency: 'MMK', amount: 15000, status: 'waitingForPayment',
    paymentMethod: 'kbzPayQR', callbackStatus: 'none', dueDate: isoMinutesFromNow(120), createdAt: new Date().toISOString(),
    product: { __typename: 'Product', id: products[0].id, title: products[0].title }, ...over,
})

const orders = [
    mkOrder({ id: 'e1', amount: 15000, status: 'paymentSuccess', paymentMethod: 'kbzPayQR', callbackStatus: 'success', createdAt: isoDaysAgo(1) }),
    mkOrder({ id: 'e2', amount: 5000, status: 'waitingForPayment', paymentMethod: 'kbzPayWeb', callbackStatus: 'none', createdAt: isoMinutesFromNow(-30), product: { __typename: 'Product', id: products[1].id, title: products[1].title } }),
    mkOrder({ id: 'e3', amount: 15000, status: 'paymentFailed', paymentMethod: 'kbzPayQR', callbackStatus: 'error', createdAt: isoDaysAgo(0) }),
    mkOrder({ id: 'e4', amount: 120000, status: 'refunded', paymentMethod: 'kbzPayQR', callbackStatus: 'success', createdAt: isoDaysAgo(2), product: { __typename: 'Product', id: products[2].id, title: products[2].title } }),
]

const overview = {
    __typename: 'Overview', revenueOfPaid: 1250000, numOfOrders: 128, numOfPaidOrders: 96,
    numOfRefundedOrders: 4, numOfFailedOrders: 11, numOfPendingOrders: 14, numOfExpiredOrders: 3,
}

const ordersWithoutProduct = orders.map((o) => {
    const copy = { ...o } as Record<string, any>
    delete copy.product
    return copy
})

const resolvers: Record<string, (v: Record<string, any>) => any> = {
    AllApps: () => ({ apps }),
    FindApp: (v) => ({ findApp: apps.find((a) => a.id === v.id) ?? apps[0] }),
    Dashboard: () => ({ dashboard: overview }),
    AllProducts: () => ({ products }),
    FindProducts: () => ({ findProducts: products }),
    FindProduct: (v) => ({ findProduct: products.find((p) => p.id === v.id) ?? products[0] }),
    GetAllOrders: () => ({ orders: ordersWithoutProduct }),
    FindOrders: () => ({ findOrders: orders }),
    CreateApp: (v) => ({ createApp: { __typename: 'App', id: newId(), name: v.name, key: `sk_live_${newId()}`, s2sUrl: v.s2sUrl } }),
    UpdateApp: (v) => ({ updateApp: { __typename: 'App', id: v.id, name: v.name, key: 'sk_live_8Kc92mDp4Qx7Rz1Lv6Nw3Ty', s2sUrl: v.s2sUrl } }),
    DeleteApp: () => ({ deleteApp: true }),
    CreateProduct: (v) => ({ createProduct: { __typename: 'Product', id: newId(), title: v.title, priceList: mkPriceList(v.MMK, v.USD), createdAt: new Date().toISOString() } }),
    UpdateProduct: (v) => ({ updateProduct: { __typename: 'Product', id: v.id, title: v.title, priceList: mkPriceList(v.MMK, v.USD), createdAt: new Date().toISOString() } }),
    CreateOrder: (v) => ({ createOrder: mkOrder({ paymentMethod: v.method, currency: v.currency }) }),
    UpdateOrder: (v) => ({ updateOrder: { ...ordersWithoutProduct[0], id: v.id, status: v.status } }),
    CheckOrder: () => ({ checkOrder: true }),
    RefundOrder: () => ({ refundOrder: true }),
}

export function resolveOperation(operationName: string | null | undefined, variables: Record<string, any> = {}): any {
    const resolver = operationName ? resolvers[operationName] : undefined
    if (!resolver) {
        // eslint-disable-next-line no-console
        console.warn(`[mock] unhandled operation: ${operationName}`)
        return {}
    }
    return resolver(variables)
}
